import React, { PropsWithChildren } from 'react';

export type EmbeddedDemoLayoutComponent = React.FC<PropsWithChildren<{}>>;

export enum EmbeddedDemoLayout {
  US_BANK = 'us-bank',
}
